module.exports = __webpack_public_path__ + "img/join-top-bg.7c586569.png";